import { LocalStorageService } from "./local-storage.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpEvent } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { HttpErrorHandler } from "./http-error-handler.service";
import {
  constants,
  LOCAL_STORAGE_KEYS,
  ROUTE_PATHS,
  USER_ROUTES,
} from "../constants/constants";
import { AppComponent } from "../app.component";
import { v4 as uuidv4 } from "uuid";
import { EMPTY, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  URL = environment.apiEndPoint; // endpoint URL
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private httpErrorHandler: HttpErrorHandler,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private localstorege: LocalStorageService,
  ) {}

  get token() {
    return this.localstorege.getLocalStore(LOCAL_STORAGE_KEYS.TOKEN);
  }

  async getHeaders(
    tokenRequired: boolean,
    formData: boolean = false,
    endPointVersion = "v1",
  ) {
    if (tokenRequired && !formData) {
      const headers = new HttpHeaders()
        .set("authorization", `Bearer ${this.token}`)
        .set("Content-Type", "application/json")
        .set("Accept-Version", endPointVersion)
        .set("x-time-zone", Intl.DateTimeFormat().resolvedOptions().timeZone)
        .set("x-idempotent-key", uuidv4());

      return headers;
    } else if (formData) {
      const headers = new HttpHeaders()
        .set("authorization", `Bearer ${this.token}`)
        .set("Accept-Version", endPointVersion)
        .set("x-time-zone", Intl.DateTimeFormat().resolvedOptions().timeZone)
        .set("x-idempotent-key", uuidv4());
      return headers;
    } else {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Accept-Version", endPointVersion)
        .set("x-time-zone", Intl.DateTimeFormat().resolvedOptions().timeZone)
        .set("x-idempotent-key", uuidv4());
      return headers;
    }
  }

  // this function should be used for fetch details without header token
  async get(path: any, authorize, loaderContinue?) {
    return new Promise(async (resolve, _) => {
      const success = (res) => {
        // toaster success message
        // if (res && res.message) {
        //     this.toastr.success(res.message);
        // }
        if (!loaderContinue) {
          this.spinner.hide();
        }
        resolve(res);
      };
      const error = (err) => {
        return this.httpErrorHandler.handleError(path, err);
      };
      const netowrkIsConnected = await this.getNetworkConnection();
      if (netowrkIsConnected) {
        const headers = await this.getHeaders(authorize, false);
        return this.http
          .get(`${this.URL}${path}`, { headers })
          .subscribe(success, error);
      } else {
        this.spinner.hide();
        this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
      }
    });
  }
  async patch(path: any, obj: any, authorize) {
    return new Promise(async (resolve, _) => {
      AppComponent.showLoader = true;
      this.spinner.show();
      const success = (res) => {
        // if (res && (res.message || res.msg)) {
        //     this.toastr.success(res.message ? res.message : res.msg);
        // }
        this.spinner.hide();
        resolve(this.forbiddenAccess(res));
      };
      const error = (err) => {
        return this.httpErrorHandler.handleError(path, err);
      };
      const netowrkIsConnected = this.getNetworkConnection();
      if (netowrkIsConnected) {
        let headers: any;
        if (path !== USER_ROUTES.SIGN_UP) {
          headers = await this.getHeaders(authorize, false);
        }
        return this.http
          .patch<any>(`${this.URL}${path}`, obj, { headers })
          .subscribe(success, error);
      } else {
        this.spinner.hide();
        this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
      }
    });
  }
  // this function should be used for post details without header token
  async post(
    path: any,
    obj: any,
    authorize: boolean,
    formData: boolean = false,
    endPointVersion = "v1",
  ) {
    return new Promise(async (resolve, _) => {
      const success = (res) => {
        // if (res && res.message) {
        //     this.toastr.success(res.message);
        // }

        this.spinner.hide();
        resolve(res);
      };
      const error = (err) => {
        resolve(err);
        return this.httpErrorHandler.handleError(path, err);
      };
      const netowrkIsConnected = await this.getNetworkConnection();
      if (netowrkIsConnected) {
        const headers = await this.getHeaders(
          authorize,
          formData,
          endPointVersion,
        );
        return this.http
          .post<any>(`${this.URL}${path}`, obj, { headers })
          .subscribe(success, error);
      } else {
        this.spinner.hide();
        this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
      }
    });
  }

  // this function should be used for post details without header token
  async put(path: any, obj: any, authorize) {
    return new Promise(async (resolve, _) => {
      const success = (res) => {
        this.spinner.hide();
        resolve(res);
      };
      const error = (err) => {
        return this.httpErrorHandler.handleError(path, err);
      };
      const netowrkIsConnected = await this.getNetworkConnection();
      if (netowrkIsConnected) {
        const headers = await this.getHeaders(authorize, false);
        return this.http
          .put<any>(`${this.URL}${path}`, obj, { headers })
          .subscribe(success, error);
      } else {
        this.spinner.hide();
        this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
      }
    });
  }
  async putFormDataReqWithToken(path: any, obj: any, authorize) {
    return new Promise(async (resolve, _) => {
      const success = (res) => {
        this.spinner.hide();
        resolve(res);
      };
      const error = (err) => {
        return this.httpErrorHandler.handleError(path, err);
      };
      const netowrkIsConnected = this.getNetworkConnection();
      if (netowrkIsConnected) {
        const headers = await this.getHeaders(authorize, true);
        return this.http
          .put<any>(`${this.URL}${path}`, obj, { headers })
          .subscribe(success, error);
      } else {
        this.spinner.hide();
        this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
      }
    });
  }

  async uploadFileWithProgress(path: any, obj: any) {
    const netowrkIsConnected = await this.getNetworkConnection();
    if (netowrkIsConnected) {
      const headers = await this.getHeaders(false, true);
      return this.http.post<any>(`${this.URL}${path}`, obj, {
        headers,
        reportProgress: true,
        observe: "events",
      });
    } else {
      this.spinner.hide();
      this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
    }
  }

  async putUploadFileWithProgress(
    path: string,
    obj: FormData,
  ): Promise<Observable<HttpEvent<any>>> {
    const networkIsConnected = await this.getNetworkConnection();

    if (!networkIsConnected) {
      this.spinner.hide();
      this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
      return EMPTY; // Return empty observable instead of undefined
    }

    const headers = await this.getHeaders(false, true);
    return this.http.put<any>(`${this.URL}${path}`, obj, {
      headers,
      reportProgress: true,
      observe: "events",
    });
  }

  async postExportData(path: any, obj: any) {
    return new Promise(async (resolve, _) => {
      const success = (res) => {
        // if (res && res.message) {
        //     this.toastr.success(res.message);
        // }
        this.spinner.hide();
        resolve(res);
      };
      const error = (err) => {
        return this.httpErrorHandler.handleError(path, err);
      };
      const options = {
        headers: await this.getHeaders(false, true),
        responseType: "text" as "json",
      };
      return this.http
        .post<any>(this.URL + path, obj, options)
        .subscribe(success, error);
    });
  }

  async delete(path: any, authorize) {
    return new Promise(async (resolve, _) => {
      const success = (res) => {
        // toaster success message
        // if (res && res.message) {
        //     this.toastr.success(res.message);
        // }
        this.spinner.hide();
        resolve(res);
      };
      const error = (err) => {
        return this.httpErrorHandler.handleError(path, err);
      };
      const netowrkIsConnected = await this.getNetworkConnection();
      if (netowrkIsConnected) {
        const headers = await this.getHeaders(authorize, false);
        return this.http
          .delete(`${this.URL}${path}`, { headers })
          .subscribe(success, error);
      } else {
        this.spinner.hide();
        this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
      }
    });
  }

  async getFile(url: any) {
    return new Promise(async (resolve, _) => {
      const success = (res) => {
        // toaster success message
        // if (res && res.message) {
        //     this.toastr.success(res.message);
        // }
        resolve(res);
      };
      const error = (err) => {
        return this.httpErrorHandler.handleError(url, err);
      };
      const netowrkIsConnected = await this.getNetworkConnection();
      if (netowrkIsConnected) {
        return this.http
          .get(url, { responseType: "blob" })
          .subscribe(success, error);
      } else {
        this.spinner.hide();
        this.toastr.error(constants.NO_INTERNET_CONNECTION_MSG);
      }
    });
  }

  getNetworkConnection() {
    const isOnline: boolean = navigator.onLine;
    if (isOnline) {
      return true;
    }
    return false;
  }
  forbiddenAccess(res) {
    if (res.status === 403) {
      this.router.navigate([ROUTE_PATHS.HOME]);
    }
    return res;
  }
}
